module.exports = __webpack_public_path__ + "img/IMG_3070 copia 1.51a5c2aa.png";